import { useEffect, useState } from "react";

import {
  initializeTheme,
  resolveThemePreference,
  subscribeThemeChanges,
} from "@/modules/theme";

const getInitialValue = () => {
  if (typeof document === "undefined") {
    return false;
  }

  initializeTheme();
  return resolveThemePreference() === "dark";
};

const useDarkMode = () => {
  const [isDark, setIsDark] = useState(getInitialValue);

  useEffect(() => {
    initializeTheme();

    return subscribeThemeChanges(({ resolvedTheme }) => {
      setIsDark(resolvedTheme === "dark");
    });
  }, []);

  return isDark;
};

export default useDarkMode;
